import { withRouter } from 'react-router-dom';
import component from './component';

export default withRouter(component);
